import { Formik } from "formik";
import Captcha from "react-numeric-captcha";
import { useEffect, useState, useRef } from "react";
import { Modal, Table, Button } from "react-bootstrap";
import * as Yup from "yup";
import { apiStagingOutdoorUrl } from "../../../../../../../constants";
import axios from "axios";
import { generateYearsList } from "../../../../../../../services/YearService";

const IaOrderDailyOrder = () => {
  const [iaInputDetail, setIaInputDetail] = useState({});
  const [captchaStatus, setCaptchaStatus] = useState(false);
  const capt = useRef();
  const [loading, setLoading] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);

  // fetching first dropDownData
  const [dratDrtLocations, setDratDrtLocations] = useState([]);
  const years = generateYearsList();
  const fetchDratDrtLocation = async () => {
    const res = await axios.post(
      `${apiStagingOutdoorUrl}/getDrtDratScheamName`
    );
    const sortedLocation = res.data.sort((a, b) =>
      a.SchemaName > b.SchemaName ? 1 : b.SchemaName > a.SchemaName ? -1 : 0
    );
    setDratDrtLocations(sortedLocation);
  };

  // get final data after sending required payload

  const [caseDetail, setCaseDetail] = useState([]);
  const [error, setError] = useState(false);
  const fetchCaseDetail = async (url, data) => {
    setLoading(true);
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const response = await axios.post(
        `${apiStagingOutdoorUrl}/${url}`,
        data,
        config
      );
      setCaseDetail(response.data);
    } catch (error) {
      setCaseDetail([]);
      setLoading(false);
      setError(true);
    }

    setLoading(false);
  };

  const initialValues = {
    drt: "",
    iaNo: "",
    iaYear: new Date().getFullYear(),
  };

  // validation
  const validationSchema = Yup.object({
    drt: Yup.string().required("Required"),
    iaNo: Yup.string()
      .trim()
      .max(8, "Maximum length is 8 characters")
      .matches(/^[0-9]+$/, "Only numbers are allowed")
      .required("Required"),
    iaYear: Yup.string().required("Required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    setIaInputDetail(values);
    const caseDetailData = {
      schemeNameDrtId: values.drt,
      iaNo: values.iaNo,
      iaYear: values.iaYear,
    };
    fetchCaseDetail("getDrtDailyOrderReportIaOrder", caseDetailData);
    setTimeout(() => {
      setIsOpenModal(true);
    }, 1000);

    setCaptchaStatus(false);
    // resetForm();
    capt.current.refresh();
  };

  useEffect(() => {
    fetchDratDrtLocation();
  }, []);

  const doubleDigitDate = (date) => {
    // let date = "25/8/2022"
    if (date) {
      let arr = date.split("/");
      if (arr[0].length === 1) arr[0] = "0" + arr[0];
      if (arr[1].length === 1) arr[1] = "0" + arr[1];

      return arr.join("/");
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          values,
          errors,
          touched,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              {/* field 1 */}

              <div className="form-group row">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-4 col-form-label mandatory"
                >
                  DRT
                </label>
                <div className="col-sm-7">
                  <select
                    className="form-control"
                    placeholder=""
                    type="text"
                    id="drt"
                    name="drt"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.drt}
                  >
                    <option>Select DRT</option>
                    {dratDrtLocations
                      .filter((item) => parseInt(item.schemeNameDrtId) < 100)
                      .map((item, index) => (
                        <option value={`${item.schemeNameDrtId}`} key={index}>
                          {item.SchemaName}
                        </option>
                      ))}
                  </select>
                  {touched.drt && errors.drt ? (
                    <div className="error">{errors.drt}</div>
                  ) : null}
                </div>
              </div>

              {/* field 2 */}

              <div className="form-group row">
                <label htmlFor="" className="col-sm-4 col-form-label mandatory">
                  IA No.
                </label>
                <div className="col-sm-7">
                  <input
                    id="iaNo"
                    name="iaNo"
                    type="text"
                    className="form-control"
                    placeholder="Enter IA No."
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.iaNo}
                    autoComplete="off"
                  />
                  {touched.iaNo && errors.iaNo ? (
                    <div className="error">{errors.iaNo}</div>
                  ) : null}
                </div>
              </div>

              {/* field 3 */}

              <div className="form-group row">
                <label htmlFor="" className="col-sm-4 col-form-label mandatory">
                  IA Year
                </label>
                <div className="col-sm-7">
                  <select
                    type="text"
                    className="form-control"
                    placeholder=""
                    id="iaYear"
                    name="iaYear"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.iaYear}
                  >
                    {years.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </select>
                  {touched.iaYear && errors.iaYear ? (
                    <div className="error">{errors.iaYear}</div>
                  ) : null}
                </div>
              </div>

              {/* field 4 */}

              <div className="form-group capcha-sec">
                <div className="col-sm-12 px-0 d-flex">
                  <Captcha
                    onChange={(status) => {
                      setCaptchaStatus(status);
                    }}
                    ref={capt}
                    required
                  />
                  <br />
                  <button
                    type="submit"
                    disabled={!captchaStatus}
                    className="btn btn-reload"
                  >
                    <i className="fas fa-search">
                      <span className="sr-only">no text</span>
                    </i>
                  </button>
                </div>
                {!captchaStatus ? (
                  <div className="captcha-text">Enter valid captcha</div>
                ) : null}
              </div>
            </form>
            {loading ? (
              <h6 className="loader">Loading ......</h6>
            ) : (
              <Modal show={isOpenModal} onHide={() => setIsOpenModal(false)}>
                <Modal.Header className="d-flex justify-content-between align-items-start">
                  DRT's IA Order Report
                  <Button
                    type="button"
                    className="close"
                    onClick={() => setIsOpenModal(false)}
                  >
                    &times;
                  </Button>
                </Modal.Header>
                <Modal.Body>
                  <div className="table-responsive mb-3">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Sr.No.</th>
                          {/* <th>Diary No.</th> */}
                          <th>IA No.</th>
                          <th>Application No.</th>
                          <th>Date of Order</th>
                          <th>View IA Order(s)</th>
                        </tr>
                      </thead>
                      {!error && caseDetail.length > 0 ? (
                        <tbody>
                          {caseDetail.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              {/* <td>{item.diaryno}</td> */}
                              <td>
                                {iaInputDetail.iaNo}/{iaInputDetail.iaYear}
                              </td>
                              <td>{item.applicantno}</td>
                              <td>{doubleDigitDate(item.dateoffiling)}</td>
                              <td>
                                <a
                                  target="_blank"
                                  href={`${item.dailyOrderPdf}`}
                                >
                                  <i className="fas fa-search">
                                    <span className="sr-only">no text</span>
                                  </i>
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan="5"> No Record Found </td>
                          </tr>
                        </tbody>
                      )}
                    </Table>
                  </div>
                </Modal.Body>
              </Modal>
            )}
          </>
        )}
      </Formik>
    </div>
  );
};

export default IaOrderDailyOrder;
